import Entertainment_Singlepiecechess_Board_00001 from '../../assets/graphics/png/entertainment_games/single_piece_chess_board/entertainment_singlepiecechess_board_00001.png';
import Entertainment_Singlepiecechess_Board_00002 from '../../assets/graphics/png/entertainment_games/single_piece_chess_board/entertainment_singlepiecechess_board_00002.png';
import Entertainment_Singlepiecechess_Board_00003 from '../../assets/graphics/png/entertainment_games/single_piece_chess_board/entertainment_singlepiecechess_board_00003.png';
import Entertainment_Singlepiecechess_Board_00004 from '../../assets/graphics/png/entertainment_games/single_piece_chess_board/entertainment_singlepiecechess_board_00004.png';
import Entertainment_Singlepiecechess_Board_00005 from '../../assets/graphics/png/entertainment_games/single_piece_chess_board/entertainment_singlepiecechess_board_00005.png';
import Entertainment_Singlepiecechess_Board_00006 from '../../assets/graphics/png/entertainment_games/single_piece_chess_board/entertainment_singlepiecechess_board_00006.png';
import Entertainment_Singlepiecechess_Board_00007 from '../../assets/graphics/png/entertainment_games/single_piece_chess_board/entertainment_singlepiecechess_board_00007.png';
import Entertainment_Singlepiecechess_Board_00008 from '../../assets/graphics/png/entertainment_games/single_piece_chess_board/entertainment_singlepiecechess_board_00008.png';
import Entertainment_Singlepiecechess_Board_00009 from '../../assets/graphics/png/entertainment_games/single_piece_chess_board/entertainment_singlepiecechess_board_00009.png';
import Entertainment_Singlepiecechess_Board_00010 from '../../assets/graphics/png/entertainment_games/single_piece_chess_board/entertainment_singlepiecechess_board_00010.png';
import Entertainment_Singlepiecechess_Board_00011 from '../../assets/graphics/png/entertainment_games/single_piece_chess_board/entertainment_singlepiecechess_board_00011.png';
import Entertainment_Singlepiecechess_Board_00012 from '../../assets/graphics/png/entertainment_games/single_piece_chess_board/entertainment_singlepiecechess_board_00012.png';
import Entertainment_Singlepiecechess_Board_00013 from '../../assets/graphics/png/entertainment_games/single_piece_chess_board/entertainment_singlepiecechess_board_00013.png';
import Entertainment_Singlepiecechess_Board_00014 from '../../assets/graphics/png/entertainment_games/single_piece_chess_board/entertainment_singlepiecechess_board_00014.png';
import Entertainment_Singlepiecechess_Board_00015 from '../../assets/graphics/png/entertainment_games/single_piece_chess_board/entertainment_singlepiecechess_board_00015.png';
import Entertainment_Singlepiecechess_Board_00016 from '../../assets/graphics/png/entertainment_games/single_piece_chess_board/entertainment_singlepiecechess_board_00016.png';
import Entertainment_Singlepiecechess_Board_00017 from '../../assets/graphics/png/entertainment_games/single_piece_chess_board/entertainment_singlepiecechess_board_00017.png';
import Entertainment_Singlepiecechess_Board_00018 from '../../assets/graphics/png/entertainment_games/single_piece_chess_board/entertainment_singlepiecechess_board_00018.png';
import Entertainment_Singlepiecechess_Board_00019 from '../../assets/graphics/png/entertainment_games/single_piece_chess_board/entertainment_singlepiecechess_board_00019.png';
import Entertainment_Singlepiecechess_Board_00020 from '../../assets/graphics/png/entertainment_games/single_piece_chess_board/entertainment_singlepiecechess_board_00020.png';

export enum SinglePieceChessBoardType {
  Board01 = 'Board01',
  Board02 = 'Board02',
  Board03 = 'Board03',
  Board04 = 'Board04',
  Board05 = 'Board05',
  Board06 = 'Board06',
  Board07 = 'Board07',
  Board08 = 'Board08',
  Board09 = 'Board09',
  Board10 = 'Board10',
  Board11 = 'Board11',
  Board12 = 'Board12',
  Board13 = 'Board13',
  Board14 = 'Board14',
  Board15 = 'Board15',
  Board16 = 'Board16',
  Board17 = 'Board17',
  Board18 = 'Board18',
  Board19 = 'Board19',
  Board20 = 'Board20',
}

export interface BoardAttributes {
  itemId: string;
  imageSource: string;
  strokeColor: string;
}

export const boardAttributes: {
  [key in SinglePieceChessBoardType]: BoardAttributes;
} = {
  [SinglePieceChessBoardType.Board01]: {
    itemId: 'chessItems-joyachessBoards-00000001',
    imageSource: Entertainment_Singlepiecechess_Board_00001,
    strokeColor: '#BFA75A',
  },
  [SinglePieceChessBoardType.Board02]: {
    itemId: 'chessItems-joyachessBoards-00000002',
    imageSource: Entertainment_Singlepiecechess_Board_00002,
    strokeColor: '#5584CC',
  },
  [SinglePieceChessBoardType.Board03]: {
    itemId: 'chessItems-joyachessBoards-00000003',
    imageSource: Entertainment_Singlepiecechess_Board_00003,
    strokeColor: '#BDBDBD',
  },
  [SinglePieceChessBoardType.Board04]: {
    itemId: 'chessItems-joyachessBoards-00000004',
    imageSource: Entertainment_Singlepiecechess_Board_00004,
    strokeColor: '#FFFFFF',
  },
  [SinglePieceChessBoardType.Board05]: {
    itemId: 'chessItems-joyachessBoards-00000005',
    imageSource: Entertainment_Singlepiecechess_Board_00005,
    strokeColor: '#85806F',
  },
  [SinglePieceChessBoardType.Board06]: {
    itemId: 'chessItems-joyachessBoards-00000006',
    imageSource: Entertainment_Singlepiecechess_Board_00006,
    strokeColor: '#FFFFFF',
  },
  [SinglePieceChessBoardType.Board07]: {
    itemId: 'chessItems-joyachessBoards-00000007',
    imageSource: Entertainment_Singlepiecechess_Board_00007,
    strokeColor: '#B6E5E6',
  },
  [SinglePieceChessBoardType.Board08]: {
    itemId: 'chessItems-joyachessBoards-00000008',
    imageSource: Entertainment_Singlepiecechess_Board_00008,
    strokeColor: '#E0891F',
  },
  [SinglePieceChessBoardType.Board09]: {
    itemId: 'chessItems-joyachessBoards-00000009',
    imageSource: Entertainment_Singlepiecechess_Board_00009,
    strokeColor: '#123C82',
  },
  [SinglePieceChessBoardType.Board10]: {
    itemId: 'chessItems-joyachessBoards-00000010',
    imageSource: Entertainment_Singlepiecechess_Board_00010,
    strokeColor: '#EB6F91',
  },
  [SinglePieceChessBoardType.Board11]: {
    itemId: 'chessItems-joyachessBoards-00000011',
    imageSource: Entertainment_Singlepiecechess_Board_00011,
    strokeColor: '#40BD47',
  },
  [SinglePieceChessBoardType.Board12]: {
    itemId: 'chessItems-joyachessBoards-00000012',
    imageSource: Entertainment_Singlepiecechess_Board_00012,
    strokeColor: '#D6CAF0',
  },
  [SinglePieceChessBoardType.Board13]: {
    itemId: 'chessItems-joyachessBoards-00000013',
    imageSource: Entertainment_Singlepiecechess_Board_00013,
    strokeColor: '#AB7C39',
  },
  [SinglePieceChessBoardType.Board14]: {
    itemId: 'chessItems-joyachessBoards-00000014',
    imageSource: Entertainment_Singlepiecechess_Board_00014,
    strokeColor: '#B08C6B',
  },
  [SinglePieceChessBoardType.Board15]: {
    itemId: 'chessItems-joyachessBoards-00000015',
    imageSource: Entertainment_Singlepiecechess_Board_00015,
    strokeColor: '#854F37',
  },
  [SinglePieceChessBoardType.Board16]: {
    itemId: 'chessItems-joyachessBoards-00000016',
    imageSource: Entertainment_Singlepiecechess_Board_00016,
    strokeColor: '#C2965D',
  },
  [SinglePieceChessBoardType.Board17]: {
    itemId: 'chessItems-joyachessBoards-00000017',
    imageSource: Entertainment_Singlepiecechess_Board_00017,
    strokeColor: '#DBC79E',
  },
  [SinglePieceChessBoardType.Board18]: {
    itemId: 'chessItems-joyachessBoards-00000018',
    imageSource: Entertainment_Singlepiecechess_Board_00018,
    strokeColor: '#F2F2F2',
  },
  [SinglePieceChessBoardType.Board19]: {
    itemId: 'chessItems-joyachessBoards-00000019',
    imageSource: Entertainment_Singlepiecechess_Board_00019,
    strokeColor: '#86B6DB',
  },
  [SinglePieceChessBoardType.Board20]: {
    itemId: 'chessItems-joyachessBoards-00000020',
    imageSource: Entertainment_Singlepiecechess_Board_00020,
    strokeColor: '#FFFFFF',
  },
};

export function getBoardTypeByItemId(
  itemId: string,
): SinglePieceChessBoardType | undefined {
  const entries = Object.entries(boardAttributes) as [
    SinglePieceChessBoardType,
    BoardAttributes,
  ][];
  for (const [boardType, attributes] of entries) {
    if (attributes.itemId === itemId) {
      return boardType;
    }
  }
  return undefined;
}
